/** 建築物構造種別 */
export const CONSTRUCTION_TYPE = {
  WOOD: '01',
  STEEL: '05',
  RC: '03'
} as const
